// True/False Question Component
// Handles user interaction for true/false trivia questions
// Follows the Section, Component & Manager System architecture

import React from 'react';

export function TrueFalseQuestion({
  trivia,
  selectedAnswer,
  showResults,
  onAnswerSelect,
  onSubmitAnswer,
  disabled = false
}) {


  const handleOptionClick = async (answerIndex) => {
    if (showResults || disabled) return;
    // For single-select questions, selecting immediately submits
    onAnswerSelect(answerIndex); // Update selection state first
    await onSubmitAnswer(answerIndex);
  };

  return (
    <div className="learn-trivia-options">
      <div className="mc-options-grid">
        {/* True Option */}
        <div
          className={`mc-option-card ${
            selectedAnswer === 0 ? 'selected' : ''
          } ${
            showResults ? (
              trivia.questionData.correctAnswer === 0 ? 'correct' :
              selectedAnswer === 0 ? 'incorrect' :
              'disabled'
            ) : ''
          }`}
          onClick={() => handleOptionClick(0)}
        >
          <div className="mc-option-header">
            {showResults && trivia.questionData.correctAnswer === 0 && (
              <div className="mc-correct-indicator">
                <i className="fa-solid fa-check"></i>
              </div>
            )}
            {showResults && selectedAnswer === 0 && trivia.questionData.correctAnswer !== 0 && (
              <div className="mc-incorrect-indicator">
                <i className="fa-solid fa-xmark"></i>
              </div>
            )}
          </div>

          <div className="mc-option-content">
            <p className="mc-option-text">True</p>
          </div>

        </div>

        {/* False Option */}
        <div
          className={`mc-option-card ${
            selectedAnswer === 1 ? 'selected' : ''
          } ${
            showResults ? (
              trivia.questionData.correctAnswer === 1 ? 'correct' :
              selectedAnswer === 1 ? 'incorrect' :
              'disabled'
            ) : ''
          }`}
          onClick={() => handleOptionClick(1)}
        >
          <div className="mc-option-header">
            {showResults && trivia.questionData.correctAnswer === 1 && (
              <div className="mc-correct-indicator">
                <i className="fa-solid fa-check"></i>
              </div>
            )}
            {showResults && selectedAnswer === 1 && trivia.questionData.correctAnswer !== 1 && (
              <div className="mc-incorrect-indicator">
                <i className="fa-solid fa-xmark"></i>
              </div>
            )}
          </div>

          <div className="mc-option-content">
            <p className="mc-option-text">False</p>
          </div>

        </div>
      </div>


      {showResults && (
        <div className="learn-trivia-result">
          <div className="learn-explanation">
            <strong>Explanation:</strong> {trivia.explanation}
          </div>
        </div>
      )}
    </div>
  );
}